import { render, staticRenderFns } from "./AccountSettingsTab.vue?vue&type=template&id=ebac6678"
import script from "./AccountSettingsTab.vue?vue&type=script&lang=js"
export * from "./AccountSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsTab.vue?vue&type=style&index=0&id=ebac6678&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebac6678')) {
      api.createRecord('ebac6678', component.options)
    } else {
      api.reload('ebac6678', component.options)
    }
    module.hot.accept("./AccountSettingsTab.vue?vue&type=template&id=ebac6678", function () {
      api.rerender('ebac6678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Settings/AccountSettingsTab.vue"
export default component.exports